import { defineReceiver, defineCommand } from '@drapejs/invoker';
import { gql } from 'graphql-request';
import { request, query } from '@motillo/drapejs-litium';

export const commands = {
  changeCountry: defineCommand<{
    url: string;
    countryId: string;
    languageId: string;
    pageId: string;
    categoryId: string;
    productId: string;
  }>('changeCountry'),
};

export const receivers = {
  changeCountry: defineReceiver(
    commands.changeCountry,
    async function (command, data) {
      const result = await request(
        this.cache,
        query(gql`
          mutation setCountry($url: String!, $countryId: String!, $languageId: String!, $pageId: String!, $categoryId: String!, $productId: String!) {
            session(url: $url) {
              setCountry {
                setCountry(countryId: $countryId, languageId: $languageId, pageId: $pageId, categoryId: $categoryId, productId: $productId) {
                  error
                  redirectUrl
                }
              }
            }
          }
        `),
        {
          url: `${(<any>command).protocol}//${(<any>command).host}${(<any>command).path}`,
          countryId: command.countryId,
          languageId: command.languageId,
          pageId: command.pageId || '',
          categoryId: command.categoryId || '',
          productId: command.productId || '',
        }
      );

      return result.data.session.setCountry.setCountry;
    },
    'litium'
  ),
};
